import {
    MarketResearchDiversityMetricResponse,
    MarketResearchDiversityOverviewResponse,
    MarketResearchDiversityResponse,
} from ".";
import {
    MarketResearchDiversityData,
    MarketResearchDiversityMetricData,
    MarketResearchDiversityOverview,
} from "../..";

/* eslint-disable prefer-spread */
export const convertMarketResearchDiversityResponse = (
    res: MarketResearchDiversityResponse
) => {
    if (!res) return null;
    const demographics = convertMarketResearchDiversityMetricResponses(
        res.ethnicDemographics
    );
    const genders = convertMarketResearchDiversityMetricResponses(
        res.genderDemographics
    );

    const overview = convertMarketResearchOverviewResponse(
        res.diversityOverview
    );

    const result: MarketResearchDiversityData = {
        overview,
        demographics,
        genders,
        ethnicityDiversity: {
            statePercent: {
                nonWhitePercent: res.demographicNonWhiteSummary.statePercent,
            },
            regionalPercent: {
                nonWhitePercent: res.demographicNonWhiteSummary.regionalPercent,
            },
        },
        genderDiversity: {
            statePercent: {
                femalePercent: res.demographicGenderFemaleSummary.statePercent,
            },
            regionalPercent: {
                femalePercent:
                    res.demographicGenderFemaleSummary.regionalPercent,
            },
        },
    };
    return result;
};

const convertMarketResearchDiversityMetricResponses = (
    res: MarketResearchDiversityMetricResponse[]
) => {
    if (!res) return null;

    return res
        .filter(r => !!r)
        .map(r => convertMarketResearchDiversityMetricResponse(r));
};

const convertMarketResearchDiversityMetricResponse = (
    res: MarketResearchDiversityMetricResponse
) => {
    if (!res) return null;

    const result: MarketResearchDiversityMetricData = {
        name: res.name,
        statePercent: res.statePercent,
        regionalPercent: res.regionalPercent,
    };

    return result;
};

const convertMarketResearchOverviewResponse = (
    res: MarketResearchDiversityOverviewResponse
) => {
    if (!res) return null;
    const result: MarketResearchDiversityOverview = {
        isRemote: res.isRemote,
        normalizedLocationName: res.normalizedLocationName,
        normalizedStateName: res.normalizedLocationStateName,
    };
    return result;
};
